import {
  Alert,
  Box,
  CircularProgress,
  Divider,
  Grid,
  Typography,
} from "@mui/material";

import React, { useMemo } from "react";
import { useQuery, useQueryClient } from "react-query";
import cubeApiClient from "../../BusinessObjects/cubeApiService";
import {
  useAppDispatch,
  useAppSelector,
} from "../../BusinessObjects/Redux/app/hook";
import { RootState } from "../../BusinessObjects/Redux/app/store";
import {
  ITabbedPage,
  setLockedByMe,
  TabbedPageObjectEdit,
} from "../../BusinessObjects/Redux/features/tabbedPage/tabbedPageSlice";
import EsaedroResourceFilter from "../../Models/EsaedroResourceFilter";
import { Form } from "../../Models/SysConf/Form";
import { FormField } from "../../Models/SysConf/FormField";
import { FormGroup } from "../../Models/SysConf/FormGroup";
import { getFormFields, getType, types } from "../../Utils/EsaedroHelper";
import { ResourceNames } from "../../Utils/ResourceNames";
import FormatTypes from "../../Utils/FormatTypes";
import { CheckBox, DateBox, NumberBox, TextArea } from "devextreme-react";
import { NativeEventInfo } from "devextreme/events";
import dxCheckBox from "devextreme/ui/check_box";
import dxDateBox from "devextreme/ui/date_box";
import dxTextArea from "devextreme/ui/text_area";
import dxTextBox from "devextreme/ui/text_box";
import dxNumberBox from "devextreme/ui/number_box";
import { ValueChangedInfo } from "devextreme/ui/editor/editor";
import Lookup, {
  EsaedroLookupHandleChangeEvent,
} from "../Esaedro/Lookup/Lookup";
import ViewerPDF from "../ViewerPDF/ViewerPDF";
import EsaedroJSONComponent from "../EsaedroJSONComponent";
import ArticoliLookup from "../CustomEdit/ArticoliLookup/ArticoliLookup";
import SaveIcon from "@mui/icons-material/Save";
import { CustomEvents } from "../../Utils/CustomEvents";
import notify from "devextreme/ui/notify";
import { LoadingButton } from "@mui/lab";
import EditIcon from "@mui/icons-material/Edit";
import { TextBox } from "devextreme-react/text-box";
import {
  ResultsSet,
  ValidationError,
} from "../../Models/Project/ValidationError";
import ResourceField from "../../Models/ResourceField";
import FieldTypes from "../../Utils/FieldTypes";
import Formbuilder from "../FormBuilder/Formbuilder";
import { Route, useNavigate } from "react-router-dom";
import { RoutePath } from "../../Utils/RoutePath";
import { FormTypeEnum } from "../../modules/app/types/FormType";
import { DateTime } from "luxon";

export const FieldsNotVisible = [
  "dat_obsoleto",
  "cod_utente_cre",
  "dat_utente_cre",
  "cod_utente_mod",
  "dat_utente_mod",
  "ts_update",
  "flg_isdeleted",
  "dat_ultvar",
];

const clone = require("clone");

export enum ErrorLevels {
  "Correct" = 0,
  "Warning" = 1,
  "Error" = 2,
}

function checkValidDate(d: any) {
  if (Object.prototype.toString.call(d) === "[object Date]") {
    // it is a date
    if (isNaN(d)) {
      // d.getTime() or d.valueOf() will also work
      // date object is not valid
      return false;
    } else {
      // date object is valid
      return true;
    }
  } else {
    // not a date
    return false;
  }
}

const ObjectEditStringQueryKey = "Object-Edit";

export type ObjectEditProps = {
  nameTabbedPage: string;

  // Utilizzato per far funzionare Redux
  idObjectEdit: number;

  myObjType: string;
  myObjUrl: string;

  myObj?: any;
  myObjResourceID?: number;
  myObjMenuItemID?: string;
  myObjJumpID?: string;

  fixedFields?: EsaedroResourceFilter[];

  onCustomHandleChange?(objChanged: any, fieldName: string): void;
  onCustomRenderField?(editedObject: any, field: FormField): void;
  onCustomUpdateObject?(editedObject: any): void;

  onReturn?(ackMessage?: string, newObj?: any): void;

  isNew: boolean;

  lastSelectedObj?: any;
  children?: React.ReactNode;
};

const ObjectEdit = (props: ObjectEditProps) => {
  const shouldLog = React.useRef(true);

  const queryClient = useQueryClient();

  let navigate = useNavigate();

  // Key incrementali delle lookup (nome campo in chiave) - Se incrementate triggerano il render sulla relativa lookup
  const [lookupKeys, setLookupKeys] = React.useState<Map<string, number>>(
    new Map()
  );

  // Mi creo le mappe per gestire le lookup come variabili fuori dallo stato
  // Nomi dei campi delle lookup che hanno campi da controllare
  // Mi creo le mappe per gestire le lookup come variabili fuori dallo stato
  // Nomi dei campi delle lookup che hanno campi da controllare
  const refLookupFieldsWithFieldsToCheck = React.useRef<string[]>([]);
  const [lookupFieldsWithFieldsToCheck, setLookupFieldsWithFieldsToCheck] =
    React.useState<string[]>([]);

  // Campi da controllare per ogni lookup (nome campo in chiave)
  const [lookupFieldsToCheck, setLookupFieldsToCheck] = React.useState<
    Map<string, any[]>
  >(new Map());

  const tokenApi = useAppSelector((state: RootState) => state.user.tokenAPI);
  const userProfile = useAppSelector(
    (state: RootState) => state.user.userProfile
  );
  const sessionId = useAppSelector((state: RootState) => state.user.sessionID);
  const pushClientUrl = useAppSelector(
    (state: RootState) => state.app.pushClientUrl
  );

  const myTabbedPageGlobal: ITabbedPage | undefined = useAppSelector(
    (state: RootState) =>
      state.tabbedPages.tabbedPages.find((x) => x.name === props.nameTabbedPage)
  );
  const myObjectEdit: TabbedPageObjectEdit | undefined = React.useMemo(() => {
    //
    if (myTabbedPageGlobal)
      return myTabbedPageGlobal.objectEdits.find(
        (x) => x.id == props.idObjectEdit
      );
    else if (props.myObjType === "EccoContrattoElettricita")
      return {
        id: 0,
        objectToEdit: undefined,
        lockedByMe: false,
        resource_ID: 0,
        item_ID: undefined,
      };
    //chiedere a Matteo se questa modifica è valida
    else return undefined;
  }, [myTabbedPageGlobal, props.idObjectEdit]);

  let dispatch = useAppDispatch();

  const [errorMessage, setErrorMessage] = React.useState("");
  const [isReduxError, setIsReduxError] = React.useState(false);

  var [myObject, setMyObject] = React.useState<any>(undefined);

  const [isUpdating, setIsUpdating] = React.useState(false);

  // Controllare se la risorsa è già stata bloccata da un altro utente
  const [isItemAvailable, setIsItemAvailable] = React.useState(false);
  const [isLoadingCheckLock, setIsLoadingCheckLock] = React.useState(false);
  const [errorMessageCheckLock, setErrorMessageCheckLock] = React.useState("");

  const [validationErrors, setValidationErrors] = React.useState<
    ValidationError[]
  >([]);
  const [isLoadingValidation, setIsLoadingValidation] = React.useState(false);

  const { data: form, isLoading: isLoadingForm } = useQuery(
    [
      props.nameTabbedPage,
      ObjectEditStringQueryKey,
      "form",
      props.idObjectEdit,
      tokenApi,
      userProfile?.customer_ID,
    ],
    () => {
      const service = new cubeApiClient();

      var urlFilter = props.myObjJumpID
        ? `jumpmenu_id=${props.myObjJumpID}`
        : props.myObjMenuItemID
        ? `MenuItemID=${props.myObjMenuItemID.split("_", 1)[0]}`
        : `ResourceId=${props.myObjResourceID}`;

      const requrl = `api/sys/${ResourceNames.Forms}/query?` + urlFilter;

      return service.getItems(requrl, tokenApi);
    },
    {
      enabled: myObjectEdit != undefined,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  React.useEffect(() => {
    if (shouldLog.current) {
      if (!props.isNew && props.myObj != undefined) {
        setMyObject(clone(props.myObj));
        // checkLock(props.myObj.Id)
      }

      shouldLog.current = false;
    }

    if (form) {
      var allFields: FormField[] = getFormFields(form[0]);

      // Creo le chiavi per le varie lookup
      allFields.forEach((field: FormField) => {
        if (field.LookupName || field.LookupValues)
          lookupKeys.set(field.FieldName, 0);
      });

      // Se è nuovo devo impostare i valori di default
      if (props.isNew) {
        let newObject = createEmptyObject(allFields);
        setMyObject(newObject);
        /*dispatch(setObjectToEdit({
                    tabbedPageName: props.nameTabbedPage,
                    objectEditId: props.idObjectEdit,
                    object: newObject
                }))*/
      } else {
        if (props.myObj != undefined) {
          setMyObject(clone(props.myObj));
          // checkLock(props.myObj.Id)
        }
      }
    }
  }, [form]);

  React.useEffect(() => {
    return () => {
      queryClient.removeQueries([
        props.nameTabbedPage,
        "objectEdit",
        "form",
        props.idObjectEdit,
        tokenApi,
      ]);
    };
  }, []);

  React.useEffect(() => {
    if (props.isNew) setIsItemAvailable(true);
    else {
      if (props.myObj && props.myObj.Id) checkLock(props.myObj.Id);
      else if (props.myObj) setIsItemAvailable(true);
    }
  }, [props.myObj, props.isNew]);

  const checkLock = (itemId: any) => {
    if (!props.myObjResourceID) return;
    if (!itemId) {
      setIsItemAvailable(true);
      console.warn("Ops! Non è stato passato l'ID dell'oggetto da controllare");
      return;
    }
    if (!pushClientUrl) {
      setIsItemAvailable(true);
      console.warn("Ops! Non è stato passato il pushClientUrl");
      return;
    }

    // Se si vuole skippare il controllo del lock in test commentare le righe sotto e decommentare la riga successiva
    // setIsItemAvailable(true);

    // dispatch(
    //   setLockedByMe({
    //     tabbedPageName: props.nameTabbedPage,
    //     objectEditId: props.idObjectEdit,
    //     lockedByMe: true,
    //   })
    // );

    setIsLoadingCheckLock(true);

    const service = new cubeApiClient();

    service
      .getLock(
        props.myObjResourceID,
        itemId,
        tokenApi,
        sessionId,
        pushClientUrl
      )
      .then((res) => {
        setIsItemAvailable(res);

        dispatch(
          setLockedByMe({
            tabbedPageName: props.nameTabbedPage,
            objectEditId: props.idObjectEdit,
            lockedByMe: res ? true : false,
          })
        );
      })
      .catch((err) => {
        setErrorMessageCheckLock(
          err && err.message
            ? err.message
            : "Errore durante il controllo del lock"
        );
        setIsItemAvailable(false);
      })
      .finally(() => {
        setIsLoadingCheckLock(false);
      });
  };
  const formFields = useMemo(() => {
    return form && form.length > 0 ? getFormFields(form[0]) : [];
  }, [form]);

  const handleChangeLookup = (event: EsaedroLookupHandleChangeEvent) => {
    let tmpObj = clone(myObject);

    const field = formFields.find(
      (ff: any) => ff.FieldName === event.fieldName
    );

    if (field) {
      const type = getType(field);
      switch (type) {
        case types.number: {
          tmpObj[event.fieldName] = parseInt(event.value, 10);
          break;
        }
        case types.string: {
          tmpObj[event.fieldName] = event.value;
          break;
        }
        case types.date: {
          tmpObj[event.fieldName] = new Date(event.value);
          break;
        }
        case types.boolean: {
          tmpObj[event.fieldName] = Boolean(event.value);
          break;
        }
        case types.datetime: {
          tmpObj[event.fieldName] = new Date(event.value);
          break;
        }
        default: {
          tmpObj[event.fieldName] = event.value;
        }
      }
    }
    if (
      event.selectedRowsData.length > 0 &&
      event.resourceLookupValues.length > 0 &&
      event.selectedRowsData.length > 0
    ) {
      for (let i = 0; i < event.resourceLookupValues.length; i++) {
        let aliasFieldName =
          event.resourceLookupValues[i].ValueField_Name_Alias;
        let ValueField_Name = event.resourceLookupValues[i].ValueField_Name;

        if (aliasFieldName && aliasFieldName !== "") {
          tmpObj[aliasFieldName] = event.selectedRowsData[0][ValueField_Name];
        } else {
          tmpObj[ValueField_Name] = event.selectedRowsData[0][ValueField_Name];
        }
      }
    }

    // Se è una lookup faccio un controllo sui campi da controllare. Se sono cambiati cambio la chiave a quella lookup, incrementandola nella relativa mappa
    refLookupFieldsWithFieldsToCheck.current.forEach((field: string) => {
      var fieldsToCheck = lookupFieldsToCheck.get(field);

      if (fieldsToCheck) {
        for (var i = 0; i < fieldsToCheck.length; i++) {
          if (fieldsToCheck[i] == event.fieldName) {
            let newKey = lookupKeys.get(field);
            if (newKey == undefined) newKey = 0;
            lookupKeys.set(field, newKey + 1);
          }
        }
      }
    });

    if (props.onCustomHandleChange)
      props.onCustomHandleChange(tmpObj, event.fieldName);

    setMyObject(tmpObj);
  };

  const handleChangeDevExtreme = (
    event: NativeEventInfo<
      dxCheckBox | dxDateBox | dxNumberBox | dxTextArea | dxTextBox
    > &
      ValueChangedInfo
  ) => {
    var name = event.element.id;
    var value = event.value;

    let tempObj = clone(myObject);
    tempObj[name] = value;

    if (props.onCustomHandleChange) props.onCustomHandleChange(tempObj, name);

    /* dispatch(setObjectToEdit({
            tabbedPageName: props.nameTabbedPage,
            objectEditId: props.idObjectEdit,
            object: tempObj
        }))*/

    setMyObject(tempObj);
  };

  const handleChangeDateBoxTime = (
    event: NativeEventInfo<dxDateBox> & ValueChangedInfo
  ) => {
    var name = event.element.id;
    var value = event.value;

    /*
            From datetime to time.
            In JS non esistono i Time perciò da un datetime(passato dalla datebox, di tipo 'time'), otteniamo il time 
            nel formato HH:mm:ss.
            substr(0,8) = serve per eliminare GTM+2(Europa centrale), se no non viene salvato nel DB
        */

    value = value.toTimeString().substr(0, 8);

    let tempObj = clone(myObject);
    tempObj[name] = value;

    if (props.onCustomHandleChange) props.onCustomHandleChange(tempObj, name);

    /* dispatch(setObjectToEdit({
            tabbedPageName: props.nameTabbedPage,
            objectEditId: props.idObjectEdit,
            object: tempObj
        }))*/

    setMyObject(tempObj);
  };

  const handleBuilder = () => {
    var urlFilter = props.myObjJumpID
      ? `${FormTypeEnum.jump}=${props.myObjJumpID}`
      : props.myObjMenuItemID
      ? `${FormTypeEnum.menu}=${props.myObjMenuItemID.split("_", 1)[0]}`
      : `${FormTypeEnum.resource}=${props.myObjResourceID}`;

    navigate(RoutePath.CREATE_FORM + "?" + urlFilter);
  };

  const handleChange = (event: any) => {
    var type = event && event.type ? event.type : "";

    if (type == CustomEvents.DeleteFile) {
      var value = undefined;
      var name = event.detail;

      let tempObj = clone(myObject);
      tempObj[name] = value;

      if (props.onCustomHandleChange) props.onCustomHandleChange(tempObj, name);

      /* dispatch(setObjectToEdit({
                tabbedPageName: props.nameTabbedPage,
                objectEditId: props.idObjectEdit,
                object: tempObj
            }))*/

      setMyObject(tempObj);
    } else if (type == CustomEvents.JSONObjectChanged) {
      var value = event.detail["value"];
      var name = event.detail["name"];

      let tempObj = clone(myObject);
      tempObj[name] = value;

      if (props.onCustomHandleChange) props.onCustomHandleChange(tempObj, name);

      /* dispatch(setObjectToEdit({
                tabbedPageName: props.nameTabbedPage,
                objectEditId: props.idObjectEdit,
                object: tempObj
            }))*/

      setMyObject(tempObj);
    } else {
      notify("Errore: tipo di evento non gestito", "error", 3000);
    }
  };

  const createEmptyObject = (formFields: FormField[]) => {
    // Creo un oggetto vuoto con le chiavi dei campi del form. Tutte le proprietà devono essere writable per i custom component
    var objToRet: any = {};

    Object.defineProperty(objToRet, "customer_ID", {
      value: userProfile?.customer_ID || -1,
      writable: true,
      configurable: true,
      enumerable: true,
    });

    formFields.forEach((field: FormField) => {
      switch (field.Field_Type) {
        // Boolean
        case 1:
        case 2:
          Object.defineProperty(objToRet, field.FieldName, {
            value: field.DefaultValue
              ? field.DefaultValue === "1"
                ? true
                : field.DefaultValue === "0"
                ? false
                : field.DefaultValue
              : false,
            writable: true,
            configurable: true,
            enumerable: true,
          });
          break;
        default:
          Object.defineProperty(objToRet, field.FieldName, {
            value: field.DefaultValue ? field.DefaultValue : undefined,
            writable: true,
            configurable: true,
            enumerable: true,
          });
          break;
      }
    });

    // Qui scorro i fixed fields per trovare l'elenco dei campi fixed e settarli
    if (props.fixedFields) {
      props.fixedFields.forEach((field: EsaedroResourceFilter, i) => {
        if (props.fixedFields && props.fixedFields[i]) {
          if (
            field.FieldName == props.fixedFields[i].FieldName &&
            props.fixedFields[i].Operator == "="
          ) {
            objToRet[field.FieldName] = props.fixedFields[i].Value;
          }
        }
      });
    }

    return objToRet;
  };

  const lookupLoadedFieldsToCheck = (
    fieldName: string,
    fieldsToCheck: any[]
  ) => {
    // Setto i fields to check nella mappa
    if (!refLookupFieldsWithFieldsToCheck.current.includes(fieldName)) {
      refLookupFieldsWithFieldsToCheck.current = [
        ...refLookupFieldsWithFieldsToCheck.current,
        fieldName,
      ];
      // lookupFieldsToCheck.set(fieldName, fieldsToCheck)
    }
    lookupFieldsToCheck.set(fieldName, fieldsToCheck);
  };

  const calculateFormat = (field: FormField) => {
    var format = "€ #,##0.";

    const fieldName = field.FieldName;

    return format;
  };

  const renderFormField = (
    field: FormField,
    index: number,
    numCols: number = 1
  ) => {
    // if (myObjectEdit === undefined || myObjectEdit.objectToEdit === undefined) return null;
    if (myObject === undefined) return null;

    var labelSizeRatio = field.LabelSizeRatio ?? 4;
    var fieldSizeRatio = field.FieldSizeRatio ?? 12 - labelSizeRatio;

    const objectToEdit = myObjectEdit?.objectToEdit || undefined;

    // Qui la lista è filtrata a monte in caso di update, va gestita in caso di insert - TODO capire come gestirla
    if (props.isNew && !field.Is_Visible && !field.Is_Key && !field.Is_Nullable)
      return null;

    // Questi campi non devono mai essere visibili
    if (FieldsNotVisible.includes(field.FieldName)) return null;

    // Se è di tipo Object List non devo mostrarlo
    if (
      field.Reffered_Resource_Type == 1 ||
      field.Is_Decode ||
      field.Is_Identity
    )
      return;

    // Avviso se c'è un errore nella programmazione della maschera
    if (
      props.isNew &&
      !field.Is_Visible &&
      (field.Is_Key || !field.Is_Nullable)
    ) {
      field.HelperText = "ERRORE - Campo chiave o non nullabile";
      field.Is_Editable = false;
    }

    // Qui scorro i fixed fields per trovare l'elenco dei campi non editabili
    if (props.fixedFields) {
      for (let i: number = 0; i < props.fixedFields.length; i++) {
        if (
          field.FieldName == props.fixedFields[i].FieldName &&
          props.fixedFields[i].Operator == "="
        ) {
          field.Is_Editable = false;
          break;
        }
      }
    }

    // Se è sync o siamo in edit ed è chiave il campo deve essere ReadOnly
    const disableEdit =
      myObject && myObject.disableEdit !== undefined && myObject.disableEdit
        ? myObject.disableEdit
        : false;
    if (field.Is_Syncronized || (field.Is_Key && !props.isNew) || disableEdit)
      field.Is_Editable = false;

    // Se è chiave e non nullabile deve essere obbligatorio
    if (field.Is_Key || !field.Is_Nullable) field.Is_Required = true;

    // Inserisco qui l'eventuale callback
    if (props.onCustomRenderField) {
      props.onCustomRenderField(myObject, field);
    }

    if (!field.Is_Visible) return null;

    // var validationError = validateField(field);

    const error: ValidationError | undefined = validationErrors.find(
      (error: ValidationError) => error.FieldName === field.FieldName
    );
    let isValid: boolean =
      error && error.ErrorLevel !== ErrorLevels.Correct ? false : true;

    let validationTypography: JSX.Element | null = null;
    if (error && error.ErrorLevel !== ErrorLevels.Correct) {
      validationTypography = (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1" color={"error"} fontSize="12px">
            {error?.Message} &nbsp;
          </Typography>
        </Box>
      );
    }

    // LABEL
    let fieldLabel: JSX.Element = (
      <Grid item xs={12} md={labelSizeRatio} display="flex">
        <Typography variant="body1">{field.Field_Label}</Typography>
        {field.Is_Required ? (
          <Typography variant="body1" color="error">
            &nbsp; *
          </Typography>
        ) : null}
      </Grid>
    );

    if (field.LookupName || field.LookupValues) {
      return (
        <Grid item xs={12} sm={12 / numCols} key={index}>
          <Grid container spacing={2}>
            {fieldLabel}
            <Grid item xs={12} md={fieldSizeRatio}>
              <Lookup
                fieldName={field.FieldName}
                value={myObject[field.FieldName]}
                fatherObj={myObject}
                onChange={handleChangeLookup}
                lookupName={field.LookupName ? field.LookupName : ""}
                lookupValues={field.LookupValues ? field.LookupValues : ""}
                displayName={field.Field_Label}
                isDisabled={!field.Is_Editable}
                onFieldsToCheckLoaded={lookupLoadedFieldsToCheck}
                key={lookupKeys.get(field.FieldName)}
                isValid={isValid}
              />
              {validationTypography}
            </Grid>
          </Grid>
        </Grid>
      );
    }

    // Controllo se è un pdf e nel caso gli assegno il Field_Type 400
    if (field.Field_Type == 200 && field.ContentType == "pdf")
      field.Field_Type = 400;
    // Controllare che il campo non sia undefined / stringa vuota
    if (
      field.Field_Type == 400 &&
      (myObject[field.FieldName] === undefined ||
        myObject[field.FieldName] === null ||
        myObject[field.FieldName] === "")
    )
      return;

    // Se il FormatType è generico allora faccio il render partendo dal Field_Type
    let type = getType(field);

    if (
      field.FormatType === undefined ||
      field.FormatType === FormatTypes.Generico
    ) {
      // Renderizzo il campo in base al tipo
      switch (type) {
        case types.boolean:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <CheckBox
                    name={field.FieldName}
                    value={
                      myObject[field.FieldName]
                        ? myObject[field.FieldName]
                        : false
                    }
                    onValueChanged={handleChangeDevExtreme}
                    disabled={!field.Is_Editable}
                    id={field.FieldName}
                    elementAttr={{
                      field: field.FieldName,
                    }}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case types.datetime:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <DateBox
                    type="date"
                    name={field.FieldName}
                    id={field.FieldName}
                    disabled={!field.Is_Editable}
                    value={myObject[field.FieldName]}
                    onValueChanged={handleChangeDevExtreme}
                    //displayFormat='dd-MM-yyyy'
                    elementAttr={{
                      field: field.FieldName,
                    }}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case types.date:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <DateBox
                    type="date"
                    name={field.FieldName}
                    id={field.FieldName}
                    disabled={!field.Is_Editable}
                    value={myObject[field.FieldName]}
                    onValueChanged={handleChangeDevExtreme}
                    //displayFormat='dd-MM-yyyy'
                    elementAttr={{
                      field: field.FieldName,
                    }}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case types.time: {
          //convertiamo il dato time in datetime al fine di visualizzarlo correttamente, per poi gestirlo nell'handleChange
          let date = new Date(Date.now());

          if (props.isNew) {
            if (myObject[field.FieldName]) {
              let myTimesStr = myObject[field.FieldName];
              let hours = myTimesStr.substr(0, 2);
              let minutes = myTimesStr.substr(3, 2);
              date.setHours(hours);
              date.setMinutes(minutes);
            } else {
              date.setMinutes(0);
            }
          } else {
            let myTimesStr = myObject[field.FieldName];

            if (myTimesStr) {
              let hours = myTimesStr.substr(0, 2);
              let minutes = myTimesStr.substr(3, 2);

              date.setHours(hours);
              date.setMinutes(minutes);
            }
          }

          date.setSeconds(0);
          date.setMilliseconds(0);

          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <DateBox
                    type="time"
                    name={field.FieldName}
                    id={field.FieldName}
                    disabled={!field.Is_Editable}
                    value={date && checkValidDate(date) ? date : undefined}
                    onValueChanged={handleChangeDateBoxTime}
                    elementAttr={{
                      field: field.FieldName,
                    }}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );
        }

        case types.number:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <NumberBox
                    name={field.FieldName}
                    id={field.FieldName}
                    disabled={!field.Is_Editable}
                    value={myObject[field.FieldName]}
                    onValueChanged={handleChangeDevExtreme}
                    elementAttr={{
                      field: field.FieldName,
                    }}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case types.pdf:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <ViewerPDF
                    file={`data:application/pdf;base64,${
                      myObject[field.FieldName]
                    }`}
                    filename={myObject.cod_nomefile}
                  />
                </Grid>
              </Grid>
            </Grid>
          );

        // A data 03/01/2023 non è utilizzato. Matteo Urso
        case types.allegato: {
          // From byte array to base64
          const b64 = `data:image/jpeg;base64,${myObject[field.FieldName]}`;

          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <img src={b64} alt="allegato" />
                </Grid>
              </Grid>
            </Grid>
          );
        }

        case types.json:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <EsaedroJSONComponent
                    component={myObject[field.FieldName]}
                    fieldName={field.FieldName}
                    canEdit={field.Is_Editable}
                    onChange={handleChange}
                    suggestedKeys={field.CustomProperty}
                    key={field.CustomProperty}
                  />
                </Grid>
              </Grid>
            </Grid>
          );

        // Se sono delle righe, non faccio nulla
        case types.righe:
          return null;

        default:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  {field.Is_MultiRow ? (
                    <TextArea
                      name={field.FieldName}
                      disabled={!field.Is_Editable}
                      value={myObject[field.FieldName]}
                      onValueChanged={handleChangeDevExtreme}
                      id={field.FieldName}
                      inputAttr={{
                        rows: field.Rows && field.Rows > 0 ? field.Rows : 4,
                      }}
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      isValid={isValid}
                    />
                  ) : // Controllo se vuole inserire un campo con una maschera: se si,
                  // controllo se il value soddisfa la maschera, se no, metto una TextBox normale
                  field.FormatMask > "" &&
                    field.FormatMaskRules != undefined &&
                    field.MaskValidation &&
                    field.MaskValidation.test(myObject[field.FieldName]) ? (
                    <TextBox
                      name={field.FieldName}
                      value={myObject[field.FieldName]}
                      onValueChanged={handleChangeDevExtreme}
                      id={field.FieldName}
                      mask={field.FormatMask}
                      maskRules={field.FormatMaskRules}
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      disabled={!field.Is_Editable}
                      showMaskMode="onFocus"
                      isValid={isValid}
                    />
                  ) : (
                    <TextBox
                      name={field.FieldName}
                      disabled={!field.Is_Editable}
                      value={myObject[field.FieldName]}
                      onValueChanged={handleChangeDevExtreme}
                      id={field.FieldName}
                      elementAttr={{
                        field: field.FieldName,
                      }}
                      placeholder={field.FormatMask}
                      isValid={isValid}
                    />
                  )}
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );
      }
    } else {
      // Renderizzo il campo in base al FormatType
      switch (field.FormatType) {
        case FormatTypes.Data:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <DateBox
                    type="date"
                    name={field.FieldName}
                    disabled={!field.Is_Editable}
                    value={myObject[field.FieldName]}
                    onValueChanged={handleChangeDevExtreme}
                    id={field.FieldName}
                    elementAttr={{
                      field: field.FieldName,
                    }}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case FormatTypes.DataOra:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <DateBox
                    type="datetime"
                    name={field.FieldName}
                    disabled={!field.Is_Editable}
                    value={myObject[field.FieldName]}
                    onValueChanged={handleChangeDevExtreme}
                    id={field.FieldName}
                    elementAttr={{
                      field: field.FieldName,
                    }}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case FormatTypes.SoloOra:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <DateBox
                    type="time"
                    name={field.FieldName}
                    id={field.FieldName}
                    disabled={!field.Is_Editable}
                    value={myObject[field.FieldName]}
                    onValueChanged={handleChangeDevExtreme}
                    //displayFormat='dd-MM-yyyy'
                    elementAttr={{
                      field: field.FieldName,
                    }}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case FormatTypes.Importo:
          const format = calculateFormat(field);

          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <NumberBox
                    format={format}
                    name={field.FieldName}
                    id={field.FieldName}
                    disabled={!field.Is_Editable}
                    value={myObject[field.FieldName]}
                    onValueChanged={handleChangeDevExtreme}
                    elementAttr={{
                      field: field.FieldName,
                    }}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case FormatTypes.Quantita:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case FormatTypes.Ditta:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case FormatTypes.Checkbox:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <CheckBox
                    name={field.FieldName}
                    disabled={!field.Is_Editable}
                    value={myObject[field.FieldName]}
                    onValueChanged={handleChangeDevExtreme}
                    id={field.FieldName}
                    elementAttr={{
                      field: field.FieldName,
                    }}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );

        case FormatTypes.Articolo:
          return (
            <Grid item xs={12} sm={12 / numCols} key={index}>
              <Grid container spacing={2}>
                {fieldLabel}
                <Grid item xs={12} md={fieldSizeRatio}>
                  <ArticoliLookup
                    value={myObject[field.FieldName]}
                    fatherObj={myObject}
                    id={field.FieldName}
                    isDisabled={!field.Is_Editable}
                    onValueChanged={handleChangeLookup}
                    showClearButton={true}
                    otherKeysToSet={[]}
                    renderDataGrid={true}
                    isValid={isValid}
                  />
                  {validationTypography}
                </Grid>
              </Grid>
            </Grid>
          );
      }
    }
  };

  const validateObject = () => {
    setIsLoadingValidation(true);

    props.onCustomUpdateObject?.(myObject);

    const service = new cubeApiClient();

    service.validateObject(props.myObjUrl, myObject, tokenApi).then(
      (result: {
        HasErrors: boolean;
        FullErrrorMessage: string;
        ResultsSet: ResultsSet[];
      }) => {
        if (result.HasErrors) {
          // Visto che l'objectEdit modifica solo un oggetto, prendo il primo ResultsSet
          const firstResultsSet =
            result.ResultsSet && result.ResultsSet.length > 0
              ? result.ResultsSet[0]
              : null;
          if (firstResultsSet) {
            setValidationErrors(firstResultsSet.Results);
            setErrorMessage(
              firstResultsSet.Results[0].Message.toString() ||
                "Errore durante la validazione."
            );
            setIsLoadingValidation(false);
          }
        } else {
          setValidationErrors([]);
          // Faccio la post di salvataggio
          updateObject();
        }

        setIsLoadingValidation(false);
      },
      (error: any) => {
        console.log(error);
        setErrorMessage("Errore durante la validazione.");

        setIsLoadingValidation(false);
      }
    );
  };

  const correctTheError = (field: FormField) => {
    return;
  };

  const updateObject = () => {
    const service = new cubeApiClient();

    const objectToEdit = myObject;

    // Inserisco qui l'eventuale callback -->SPOSTATO nell Validate
    //props.onCustomUpdateObject?.(objectToEdit);

    setIsUpdating(true);

    // Recupero i resourcesFields
    const reqFieldsurl =
      `api/sys/${ResourceNames.ResourcesFields}?RecordSelection=` +
      encodeURIComponent(`ResourceName='${props.myObjType}'`);
    service.getItems(reqFieldsurl, tokenApi).then(
      (data: ResourceField[]) => {
        data.forEach((field) => {
          // Se il campo è di tipo lista lo elimino
          if (FieldTypes.righe.includes(field.Field_Type)) {
            delete objectToEdit[field.FieldName];
          }
        });

        service.updateObject(objectToEdit, props.myObjUrl, tokenApi).then(
          () => {
            setErrorMessage("");
            setIsUpdating(false);
            if (props.onReturn) {
              let successMsg = "Operazione avvenuta con successo!";
              props.onReturn(successMsg, objectToEdit);
            }
          },
          (error: any) => {
            // Rimane qui. Problema col timestamp?
            let stringError = "Errore nel salvataggio:" + JSON.stringify(error);
            setErrorMessage(stringError);
            setIsUpdating(false);
          }
        );
      },
      (error: any) => {
        notify("Errore nel recupero dei campi", "error", 2000);
        setIsUpdating(false);
      }
    );
  };

  const formToRender: Form = React.useMemo(() => {
    if (form) return form[0];
  }, [form]);

  const formsGroups: FormGroup[] = React.useMemo(() => {
    if (formToRender) return formToRender.FormsGroups;
    else return [];
  }, [formToRender]);

  if (isReduxError || !myObjectEdit) {
    return (
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            gutterBottom
            color="error"
            textTransform={"uppercase"}
            fontWeight={600}
          >
            {errorMessage}
          </Typography>
        </Box>
      </Box>
    );
  }

  if (isLoadingForm || !formToRender || !formsGroups || isLoadingCheckLock) {
    return (
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      </Box>
    );
  }

  if (!myObject) {
    return (
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            gutterBottom
            color="error"
            textTransform={"uppercase"}
            fontWeight={600}
          >
            Caricamento oggetto fallito...
          </Typography>
        </Box>
      </Box>
    );
  }

  if (!isItemAvailable) {
    return (
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            gutterBottom
            color="error"
            textTransform={"uppercase"}
            fontWeight={600}
          >
            {errorMessageCheckLock
              ? errorMessageCheckLock
              : "L'oggetto non è disponibile"}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Typography
        variant="h6"
        component="div"
        gutterBottom
        color="primary"
        textTransform={"uppercase"}
        fontWeight={600}
        textAlign={"center"}
      >
        {formToRender && formToRender.Title ? formToRender.Title : ""}
        <Formbuilder onClick={handleBuilder} />
      </Typography>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid container spacing={2}>
          {formsGroups.map((group: FormGroup, i) => {
            const numCols =
              formToRender && formToRender.NumerOfColumns
                ? formToRender.NumerOfColumns
                : 1;

            return (
              <React.Fragment key={i}>
                <Grid item xs={12} sm={12}>
                  <Typography
                    variant="body2"
                    component="div"
                    gutterBottom
                    color="inherit"
                    textTransform={"uppercase"}
                    fontWeight={600}
                  >
                    {group && group.GroupTitle ? group.GroupTitle : ""}
                  </Typography>
                  <Divider sx={{ my: 1 }} />
                </Grid>
                {group.FormsFields && group.FormsFields.length > 0
                  ? group.FormsFields.map((field: FormField, j) => {
                      return renderFormField(field, j, numCols);
                    })
                  : null}
              </React.Fragment>
            );
          })}
        </Grid>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <LoadingButton
          variant="contained"
          color="primary"
          onClick={validateObject}
          // disabled={isEqual(myObject, myObjectEdit.objectToEdit)}
          startIcon={<SaveIcon />}
          loading={isUpdating || isLoadingValidation}
        >
          Salva
        </LoadingButton>
      </Box>
      {errorMessage && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ marginTop: 2 }}
        >
          <Alert
            severity="error"
            sx={{
              width: "400px",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            {" "}
            {errorMessage}
          </Alert>
        </Box>
      )}
    </Box>
  );
};

export default ObjectEdit;
